<div class="ss-toast" [attr.role]="tone === 'error' ? 'alert' : 'status'" [attr.aria-live]="tone === 'error' ? 'assertive' : 'polite'">
  <span class="ss-toast__icon"><lucide-icon [name]="icon" [size]="18" aria-hidden="true"></lucide-icon></span>

  <div class="ss-toast__content">
    <div *ngIf="title()" class="ss-toast__title">
      {{ title() }}
      <span *ngIf="duplicatesCount" class="ss-toast__count">{{ duplicatesCount + 1 }}×</span>
    </div>
    <div *ngIf="options().enableHtml; else plainMessage" class="ss-toast__message" [innerHTML]="message()"></div>
    <ng-template #plainMessage><div class="ss-toast__message">{{ message() }}</div></ng-template>

    <div *ngIf="actionLabel" class="ss-toast__actions">
      <button type="button" (click)="runAction($event)">{{ actionLabel }}</button>
      <button type="button" (click)="dismiss($event)">Dispensar</button>
    </div>
  </div>

  <button type="button" class="ss-toast__close" aria-label="Fechar notificação" (click)="dismiss($event)">
    <lucide-icon name="x" [size]="16" aria-hidden="true"></lucide-icon>
  </button>

  <div *ngIf="options().progressBar" class="toast-progress" [style.width.%]="width()"></div>
</div>
